import {UserPreferencesService} from '@app/service/user-preferences.service';
import {shortcutConModalidad} from '@app/utils/menu-modalidad-venta';
import {
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {ShortcutMenu} from '@app/domain/shortcut-menu';
import {catchError, distinctUntilChanged, map, Observable, of, Subject, switchMap, takeUntil} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {SesionState} from '@app/state/sesion/sesion.state';
import {LoginService} from '@app/service/login.service';
import {ShortcutService} from '@app/service/shortcut.service';
import {MenuItem, MessageService} from 'primeng/api';
import {environment} from '@env/environment';
import {SetStatusClientWhatsappEvolution} from '@app/state/sesion/sesion.actions';
import {ConfigCompany} from '@app/domain/config-company';
import {SocketIoService} from '@app/service/socket-io.service';
import {EventEnum} from '@app/enums/event.enum';
import {WhatsappService} from '@app/service/whatsapp.service';
import {TemaService} from '@app/service/tema.service';
import {MARCA} from '@app/config/plantilla';
import {menuShortcuts} from './menu.opciones';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    standalone: false
})
export class AppTopBarComponent implements OnInit, OnDestroy {
    readonly marca = MARCA;
    private unsubscribe$ = new Subject<void>();
    shortcuts: ShortcutMenu[] = [];
    private shortcutsBase: ShortcutMenu[] = [];

    // tslint:disable-next-line:variable-name
    _roles: any[];
    urlImageLogo: string;

    @Select(SesionState.getConfig) configCompany$: Observable<ConfigCompany>;
    configCompany: ConfigCompany = {};

    @Select(SesionState.getStatusClientWhatsappEvolution) statusClientWhatsappstatusEvolution$: Observable<'open' | 'close' | 'connecting'>;

    @Select(SesionState.getAppVersion) appVersion$: Observable<string>;

    shortcutsMenuItems: MenuItem[] = [];

    statusClientPrinterCoffe: boolean;
    printerClientsVisible = false;
    statusClientWhatsapp: boolean;
    WhatsappClientLogued = false;

    WhatsappEvolucionInstance = false;
    WhatsappEvolucionLogued = false;

    @Input()
    set roles(roles: any[]) {
        this._roles = roles;
        this.loadShortcuts();
    }

    get roles() {
        return this._roles;
    }

    constructor(public appMain: AppMainComponent, private loginService: LoginService,
                private store: Store,
                private shortcutService: ShortcutService,
                private messageService: MessageService,
                private socketIoService: SocketIoService,
                private whatsappService: WhatsappService,
                public tema: TemaService,
                private preferences: UserPreferencesService
            ) {}

    get printerConnectionLabel(): string {
        const office = this.store.selectSnapshot(SesionState.getOffice);
        const officeName = office?.nombre || office?.codigo || 'sin sede seleccionada';
        const status = this.statusClientPrinterCoffe ? 'Equipo de impresión conectado' : 'Sin equipos de impresión conectados';
        return `${status} en la sede activa de ${MARCA}: ${officeName}.`;
    }

    ngOnInit(): void {
        this.preferences.changes$.pipe(
            distinctUntilChanged((a, b) => a.saleMode === b.saleMode), takeUntil(this.unsubscribe$)).subscribe(() => this.refreshShortcuts());
        void this.preferences.load().catch(() => undefined);
        this.configCompany$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(c => this.configCompany = c);
        // La comprobación inicial informa al indicador, sin interrumpir la pantalla con avisos.
        this.configCompany$.pipe(
            map(config => config?.tipoClienteWhatsapp),
            distinctUntilChanged(),
            switchMap(type => type === 'EVOLUTION'
                ? this.whatsappService.getStatusInstanceWhatsapp(true).pipe(catchError(() => of(null)))
                : of(null)),
            takeUntil(this.unsubscribe$)
        ).subscribe(data => {
            const state = data?.instance?.state;
            const status = state === 'open' || state === 'connecting' ? state : 'close';
            this.WhatsappEvolucionLogued = status === 'open';
            this.store.dispatch(new SetStatusClientWhatsappEvolution(status));
        });
        this.urlImageLogo = environment.urlLogo;

        this.statusClientWhatsappstatusEvolution$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                this.WhatsappEvolucionLogued = data === 'open';
            });
        this.socketIoService.onEvent(EventEnum.STATUS_CLIENT_PRINTER)
            .pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(data => {
                console.log(data);
                this.statusClientPrinterCoffe = data;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    get isTypeClientPrintCoffe() {
        return this.configCompany?.clienteImpresion === 'COFFE' || this.configCompany?.clienteImpresion === 'COFFE_LOCAL';
    }

    get whatsappVisible() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION'
            || (this.configCompany?.tipoClienteWhatsapp === 'SOCKET' && this.statusClientWhatsapp);
    }

    get whatsappConnected() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION' ? this.WhatsappEvolucionLogued : this.WhatsappClientLogued;
    }

    get whatsappRoute() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION' ? '/whatsapp/whatsapp-login' : '/whatsapp/estado-session';
    }

    get inlineShortcuts() {
        return this.shortcuts.slice(0, 6);
    }

    onAvatarError(event: Event) {
        (event.target as HTMLImageElement).src = 'assets/layout/images/default-avatar.png';
    }

    loadShortcuts() {
        if (this.roles) {
            this.shortcutService.findAll(this.loginService.getUser().empresa.id, false).subscribe(data => {
                // El icono se guarda al crear el acceso: el del catálogo manda para que los antiguos tomen el actual
                this.shortcutsBase = data.map(s => ({...s,
                    icono: menuShortcuts.find(op => op.value.ruta === s.ruta)?.value.icono ?? s.icono}));
                this.refreshShortcuts();
            });
        }
    }

    private refreshShortcuts(): void {
        this.shortcuts = this.roles ? this.shortcutsBase.map(s => shortcutConModalidad(s, this.preferences.saleMode)) : [];
        if (this.roles) {
            this.shortcuts.forEach(s => {
                const rolesRequired = (s.roles || '').split(',');
                s.visible = rolesRequired.some(role => this.roles.includes(role));
            });
            this.shortcuts = this.shortcuts.filter(s => s.visible);
        }
        this.buildShortcutsMenu();
    }

    private buildShortcutsMenu() {
        // el menú lleva la lista completa: en desktop complementa los iconos
        // visibles y en móvil es el único punto de acceso
        const items: MenuItem[] = this.shortcuts
            .map(s => ({label: s.nombre, icon: s.icono, routerLink: s.ruta, queryParams: s.queryParams}));
        this.shortcutsMenuItems = [
            ...items,
            ...(items.length ? [{separator: true} as MenuItem] : []),
            {label: 'Personalizar accesos', icon: 'pi pi-cog', routerLink: '/accesos-directos'}
        ];
    }

}
